const DEFAULT_PARAMS = {
  autoplay: false,
  mute: false,
  loop: false,
  controls: true,
  start: 0
}

const buildQueryString = (params) => {
  const options = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== false) {
      if (typeof value === 'boolean') {
        options.set(key, value.toString())
      } else {
        options.set(key, value.toString())
      }
    }
  })
  return options.toString() ? `?${options.toString()}` : ''
}

const VIDEO_PROVIDERS = {
  'estage.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoplay: params.autoplay,
        mute: params.mute,
        loop: params.loop,
        controls: params.controls,
        start: params.start > 0 ? params.start : undefined,
        playsinline: true
      }
      return `https://player.estage.com/${id}${buildQueryString(queryParams)}`
    }
  },
  'youtube.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regex)
      const queryParams = {
        autoplay: params.autoplay ? 1 : 0,
        mute: params.mute ? 1 : 0,
        loop: params.loop ? 1 : 0,
        controls: params.controls ? 1 : 0,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        enablejsapi: 1,
        disablekb: 1,
        playsinline: 1,
        iv_load_policy: 3,
        start: params.start > 0 ? params.start : undefined
      }
      return match ? `https://www.youtube.com/embed/${match[2]}${buildQueryString(queryParams)}` : url
    }
  },
  'vimeo.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const match = url.match(/vimeo.*\/(\d+)/i)
      const queryParams = {
        autoplay: params.autoplay ? 1 : 0,
        muted: params.mute ? 1 : 0,
        loop: params.loop ? 1 : 0,
        controls: params.controls ? 1 : 0,
        background: 1,
        playsinline: 1,
        transparent: 1,
        quality: 'auto',
        t: params.start > 0 ? params.start : undefined
      }
      return match ? `https://player.vimeo.com/video/${match[1]}${buildQueryString(queryParams)}` : url
    }
  },
  'app.screencast.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoplay: params.autoplay,
        mute: params.mute,
        loop: params.loop,
        controls: params.controls,
        start: params.start > 0 ? params.start : undefined,
        playsinline: true
      }
      return `https://www.screencast.com/t/${id}${buildQueryString(queryParams)}`
    }
  },
  'loom.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoplay: params.autoplay,
        mute: params.mute,
        hideEmbedTopBar: !params.controls,
        hide_owner: true,
        hide_share: true,
        hide_title: true,
        playsinline: true,
        time: params.start > 0 ? params.start : undefined
      }
      return `https://www.loom.com/embed/${id}${buildQueryString(queryParams)}`
    }
  },
  'wistia.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoPlay: params.autoplay,
        muted: params.mute,
        endVideoBehavior: params.loop ? 'loop' : 'default',
        controlsVisibleOnLoad: params.controls,
        playbackRate: true,
        playButton: false,
        smallPlayButton: false,
        volumeControl: false,
        fullscreenButton: false,
        playsinline: true,
        time: params.start > 0 ? params.start : undefined
      }
      return `https://fast.wistia.com/embed/iframe/${id}${buildQueryString(queryParams)}`
    }
  },
  'mega.nz': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoplay: params.autoplay,
        mute: params.mute,
        loop: params.loop,
        controls: params.controls,
        start: params.start > 0 ? params.start : undefined,
        playsinline: true
      }
      return `https://mega.nz/embed/${id}${buildQueryString(queryParams)}`
    }
  },
  'adilo.bigcommand.com': {
    transform: (url, params = DEFAULT_PARAMS) => {
      const id = url.split('/').pop()
      const queryParams = {
        autoplay: params.autoplay,
        mute: params.mute,
        loop: params.loop,
        controls: params.controls,
        start: params.start > 0 ? params.start : undefined,
        playsinline: true
      }
      return `https://player.adilo.com/${id}${buildQueryString(queryParams)}`
    }
  }
}

export const getEmbedUrl = (url, params = DEFAULT_PARAMS) => {
  const provider = Object.keys(VIDEO_PROVIDERS).find(key => url.includes(key))
  return provider ? VIDEO_PROVIDERS[provider].transform(url, params) : url
}